export default "__VITE_ASSET__gvh$l906__"